<template>
  <div class="left-row">
    <big-title :imgSrc="require('@/assets/images/bigScreen/icon-yq.png')" title="园区介绍" style="height: 35%">
      <div class="introduce">
        {{infoData.parkDiscription}}
        <!-- 虹桥国际科技广场，项目位于长宁区金钟路999号近淞虹路，电话：6218 6996；虹桥科技广场总建筑面积约9.5万平方米，其中公共绿地面积约11330平方米。按照5A级研发中心为标准进行设计建造，依照“园林式、高科技、总部型”的定位理念打造的5A级商务办公楼。虹桥科技广场由四栋造型现代的高科技建筑共同构成，是虹桥临空经济园区内罕见的，以国际5A级标准打造的高规格商务中心。集研发、办公、展示、会议于一体的完善配套商务设施，不仅适合跨国公司及国内外著名企业设置区域总部，同时也是作为研发中心、销售展示中心，现代物流中心、营运管理中心以及结算中心的理想商务平台。除了项目内部园林式的绿化景观配套，及园区内多家银行、会计师事务所为投资者提供各类金融服务，目前还有虹桥交通枢纽站的规划定位为园区带来更多样化的商务、休闲配套。物业公司：上海鑫达物业管理有限公司 -->
      </div>
    </big-title>
    <big-title
    :imgSrc="require('@/assets/images/bigScreen/icon-cz.png')"
    title="已入驻企业"
    style="height: 65%;"
    viceTitle="查看所有入驻企业"
    @viceTitleClick="viceTitleClick">
      <settled-enterprise :listData="infoData.coDateCoListMap"/>
    </big-title>
    <all-enterprise ref="AllEnterprise" :coList="coList"/>
  </div>
</template>

<script>
import BigTitle from './bigTitle.vue'
import SettledEnterprise from './SettledEnterprise.vue'
import AllEnterprise from './allEnterprise.vue'
export default {
  data () {
    return {
      coList: []
    }
  },
  components: {
    BigTitle,
    SettledEnterprise,
    AllEnterprise
  },
  props: {
    infoData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    'infoData.coList': {
      handler: function (val) {
        this.coList = [].concat(val)
      },
      deep: true
    }
  },
  methods: {
    viceTitleClick () {
      this.$refs.AllEnterprise.showDetails()
    }
  }
}
</script>

<style lang="scss" scoped>
.left-row {
  position: absolute;
  right: 0.3rem;
  top: 0;
  padding: 0.1rem 0.2rem;
  box-sizing: border-box;
  width: 5rem;
  margin-top: 0.2rem;
  height: 95%;
  background: linear-gradient(to left, rgba(11,39,64, 0.70), rgba(10,35,57, 0.33));
  .introduce {
    color: #fff;
    font-size: 0.12rem;
    line-height: 0.28rem;
  }
}
</style>